import clsx from "clsx";
import { imgLogo2 } from "@/shared/assets/img";
import { RussiaFlagIcon, TriangleArrowDownIcon } from "@/shared/icons";

export default function PlayerMenuLocalization() {
  return (
    <div className={clsx("w-[25rem] flex items-center justify-between gap-4 px-10")}>
      <img src={imgLogo2} alt="" className="w-[9.25rem]" />
      <div className="flex items-center gap-2.5">
        <div className="flex items-center justify-center h-[2.125rem] aspect-square rounded-full border-2 border-[#1F1F1F] shrink-0">
          <RussiaFlagIcon size={24} />
        </div>
        <div className="relative flex items-center gap-2 group">
          <div className="text-13 font-semibold">RU</div>
          <TriangleArrowDownIcon size={8} className="group-hover:rotate-180 transition-all" />
          <div className="absolute top-full hidden group-hover:block">
            <div className="p-2">
              <button type="button" className="text-13 font-semibold">
                RU
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
